import { render, staticRenderFns } from "./ParcelVolumeWeight.vue?vue&type=template&id=6369d0b5&"
import script from "./ParcelVolumeWeight.vue?vue&type=script&lang=js&"
export * from "./ParcelVolumeWeight.vue?vue&type=script&lang=js&"
import style0 from "./ParcelVolumeWeight.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports